export const NUMBER_OF_CHILDREN = [
	{
		value: 0,
		label: 'Nincs gyermekem'
	},
	{
		value: 1,
		label: '1'
	},
	{
		value: 2,
		label: '2'
	},
	{
		value: 3,
		label: '3'
	},
	{
		value: 4,
		label: '4 vagy több'
	}
];
